module.exports = __webpack_public_path__ + "static/media/path.14eda83c.JPG";